// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3rpIc","name":"Card_name__3YKZR","digitsGroup":"Card_digitsGroup__26bma","digits":"Card_digits__2lP-N","trash":"Card_trash__3wQ9u","dance":"Card_dance__iL18o"};